export const TITLE_YOUR_INFORMATION = {
  en_US: 'We need your information',
  pt_BR: 'Precisamos dos seus dados pessoais',
  es_ES: 'Necesitamos tu información personal',
};
